"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/AticleCardWithImage/index.ts
var AticleCardWithImage_exports = {};
__export(AticleCardWithImage_exports, {
  ArticleCardWithImage: () => ArticleCardWithImage,
  makeAticleCardWithImageTheme: () => makeAticleCardWithImageTheme,
  useVariantBasedOnScreenSize: () => useVariantBasedOnScreenSize
});
module.exports = __toCommonJS(AticleCardWithImage_exports);

// src/AticleCardWithImage/AticleCardWithImage.tsx
var import_styled_components10 = __toESM(require("styled-components"));
var import_react12 = __toESM(require("react"));

// src/AticleCardWithImage/ArticelCardTemplateSimple.tsx
var import_styled_components8 = __toESM(require("styled-components"));
var import_react10 = __toESM(require("react"));

// src/ArticleCard/ArticleCard.tsx
var import_styled_components = __toESM(require("styled-components"));
var import_react = __toESM(require("react"));
function ArticleCard({ children, className }) {
  return /* @__PURE__ */ import_react.default.createElement(ArticleCardCss, { className }, children);
}
var ArticleCardCss = import_styled_components.default.div`
  background: ${(p) => p.theme.colors.white};
  padding: ${(p) => `${p.theme.sizes.spacing4}`};
`;

// src/ArticleCard/ArticleCardFooter.tsx
var import_styled_components3 = __toESM(require("styled-components"));
var import_react4 = __toESM(require("react"));

// src/Tag/Tag.tsx
var import_styled_components2 = __toESM(require("styled-components"));
var import_react2 = __toESM(require("react"));

// src/theme/helpers/create-variant-selector.ts
var createVariantSelector = (key, variants) => {
  return function selector(themeKey, values) {
    return (p) => {
      const idx = variants.findIndex((v) => v === p[key]);
      const value = values[idx];
      return `${p.theme[themeKey][value]}`;
    };
  };
};

// src/Tag/Tag.tsx
var variantSize = createVariantSelector("size", [
  "small",
  "medium"
]);
function Tag({ text, size = "medium", bgColor = "neutral" }) {
  return /* @__PURE__ */ import_react2.default.createElement(TagCss, { size, bgColor }, text);
}
var TagCss = import_styled_components2.default.div`
  ${(p) => p.theme.getFontStyle("primary", "semiBold")}
  font-size: ${variantSize("typography", ["textXxs", "textSm2"])};
  width: fit-content;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: ${(p) => p.bgColor === "neutral" ? p.theme.tag.bgNeutral : p.theme.tag.bgPrimary};
  border-radius: ${variantSize("sizes", ["borderRadiusXs", "borderRadiusSm2"])};
  color: ${(p) => p.theme.tag.textColor};
  text-transform: uppercase;
  padding: 0.15em 0.4em 0.1em;
  white-space: nowrap;
`;

// src/FontIcon/FontIcon.tsx
var import_classnames = __toESM(require("classnames"));
var import_react3 = __toESM(require("react"));
function FontIcon({
  name,
  className,
  onClick,
  onError,
  externaltestid
}) {
  name = name.toLowerCase();
  return /* @__PURE__ */ import_react3.default.createElement(
    "span",
    {
      className: (0, import_classnames.default)(className, `bwicon-${name}`),
      onClick,
      "aria-hidden": "true",
      "data-externaltestid": externaltestid,
      onError
    },
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path1" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path2" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path3" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path4" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path5" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path6" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path7" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path8" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path9" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path10" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path11" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path12" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path13" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path14" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path15" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path16" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path17" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path18" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path19" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path20" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path21" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path22" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path23" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path24" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path25" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path26" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path27" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path28" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path29" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path30" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path31" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path32" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path33" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path34" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path35" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path36" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path37" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path38" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path39" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path40" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path41" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path42" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path43" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path44" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path45" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path46" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path47" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path48" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path49" }),
    /* @__PURE__ */ import_react3.default.createElement("span", { className: "path50" })
  );
}

// src/ArticleCard/ArticleCardFooter.tsx
function ArticleCardFooter({
  tags = [],
  hasVideo,
  className
}) {
  return /* @__PURE__ */ import_react4.default.createElement(ArticleCardFooterCss, { className }, tags.map((tag, idx) => /* @__PURE__ */ import_react4.default.createElement(Tag, { key: `tag-${idx}`, size: "small", text: tag, bgColor: "primary" })), hasVideo && /* @__PURE__ */ import_react4.default.createElement(ArticleVideoIconCss, { name: "player_stream_icon" }));
}
var ArticleCardFooterCss = import_styled_components3.default.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  gap: ${(p) => p.theme.sizes.spacing1};
`;
var ArticleVideoIconCss = (0, import_styled_components3.default)(FontIcon)`
  font-size: ${(p) => p.theme.typography.textBase2};
  color: ${(p) => p.theme.colors.primary500};

  &:not(:last-child) {
    margin-right: ${(p) => p.theme.sizes.spacing1};
  }
`;

// src/ArticleCard/ArticleCardTitle.tsx
var import_styled_components4 = __toESM(require("styled-components"));
var import_react5 = __toESM(require("react"));
function ArticleCardTitle({
  large,
  children,
  className
}) {
  return /* @__PURE__ */ import_react5.default.createElement(ArticleCardTitleCss, { className, large }, children);
}
var ArticleCardTitleCss = import_styled_components4.default.h3`
  ${(p) => p.theme.getFontStyle("secondary", "semiBold")}
  font-size: ${(p) => p.large ? p.theme.typography.text2Xl : p.theme.typography.textXl};
  color: ${(p) => p.theme.articleCard.titleColor};
  line-height: 1.4;
  margin-top: ${(p) => p.theme.sizes.spacing2};
`;

// src/ArticleCard/ArticleCardSummary.tsx
var import_styled_components5 = __toESM(require("styled-components"));
var import_react6 = __toESM(require("react"));
function ArticleCardSummary({
  children,
  className
}) {
  return /* @__PURE__ */ import_react6.default.createElement(ArticleCardSummaryCss, { className }, children);
}
var ArticleCardSummaryCss = import_styled_components5.default.p`
  ${(p) => p.theme.getFontStyle("primary", "medium")}
  font-size: ${(p) => p.theme.typography.textSm2};
  color: ${(p) => p.theme.articleCard.summaryColor};
  line-height: 1.46;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// src/ArticleCard/ArticleCardMeta.tsx
var import_react9 = __toESM(require("react"));

// src/ArticleMeta/ArticleMeta.tsx
var import_styled_components7 = __toESM(require("styled-components"));
var import_react8 = __toESM(require("react"));

// src/ArticleDetailAuthor/ArticleDetailAuthor.tsx
var import_styled_components6 = __toESM(require("styled-components"));
var import_react7 = __toESM(require("react"));
var variantSize2 = createVariantSelector("size", [
  "small",
  "medium",
  "large"
]);
function ArticleDetailAuthor({
  displayAuthorIcon,
  imageUrl,
  name,
  size = "medium"
}) {
  return /* @__PURE__ */ import_react7.default.createElement(ArticleDetailAuthorCss, null, (imageUrl || displayAuthorIcon) && /* @__PURE__ */ import_react7.default.createElement(ArticleDetailAuthorImageWrapperCss, null, imageUrl && /* @__PURE__ */ import_react7.default.createElement(ArticleDetailAuthorImageCss, { size, src: imageUrl }), !imageUrl && displayAuthorIcon && /* @__PURE__ */ import_react7.default.createElement(ArticleIconCss, { name: "icon-user" })), name && /* @__PURE__ */ import_react7.default.createElement(ArticleDetailAuthorNameCss, { size }, name));
}
var ArticleDetailAuthorImageWrapperCss = import_styled_components6.default.div`
  margin-right: ${(p) => p.theme.sizes.spacing3};
`;
var ArticleIconCss = (0, import_styled_components6.default)(FontIcon)`
  color: ${(p) => p.theme.articleDetailAuthor.nameColor};
  display: block;
  width: ${(p) => p.theme.articleDetailAuthor.authorIconWidth};
`;
var ArticleDetailAuthorCss = import_styled_components6.default.div`
  display: flex;
  align-items: center;
`;
var ArticleDetailAuthorNameCss = import_styled_components6.default.span`
  ${(p) => p.theme.getFontStyle("primary", "regular")}
  color: ${(p) => p.theme.articleDetailAuthor.nameColor};
  font-size: ${variantSize2("typography", ["textXxxs", "textSm2", "textBase2"])};
  line-height: 1.8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
var ArticleDetailAuthorImageCss = import_styled_components6.default.img`
  width: ${variantSize2("sizes", ["spacing8", "spacing9", "spacing10"])};
  border-radius: ${(p) => p.theme.sizes.borderRadiusFull};
`;

// src/ArticleMeta/ArticleMeta.tsx
function ArticleMeta({
  authorName,
  displayAuthorIcon,
  authorImageUrl,
  size = "medium",
  infos,
  className,
  readTime
}) {
  return /* @__PURE__ */ import_react8.default.createElement(ArticleMetaCss, { className }, authorName && /* @__PURE__ */ import_react8.default.createElement(
    ArticleDetailAuthor,
    {
      size,
      name: authorName,
      displayAuthorIcon,
      imageUrl: authorImageUrl
    }
  ), /* @__PURE__ */ import_react8.default.createElement(ArticleMetaInfoWrapperCss, null, /* @__PURE__ */ import_react8.default.createElement("div", null, infos == null ? void 0 : infos.map((info, idx) => /* @__PURE__ */ import_react8.default.createElement(ArticleMetaInfoCss, { key: `article-meta-info-${idx}`, size }, info))), readTime && /* @__PURE__ */ import_react8.default.createElement(ArticleMetaInfoCss, { size }, readTime)));
}
var ArticleMetaInfoWrapperCss = import_styled_components7.default.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
`;
var ArticleMetaCss = import_styled_components7.default.div`
  display: grid;
  align-items: center;
  grid-template-columns: minmax(0, min-content) 1fr;

  & > div:first-child,
  span:not(:last-child) {
    margin-right: ${(p) => p.theme.sizes.spacing2};
  }
`;
var ArticleMetaInfoCss = import_styled_components7.default.span`
  ${(p) => p.theme.getFontStyle("primary", "regular")}
  font-size: ${variantSize2("typography", ["textXxxs", "textSm2", "textBase2"])};
  line-height: 1.8;
  color: ${(p) => p.theme.articleMeta.infoColor};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// src/ArticleCard/ArticleCardMeta.tsx
function ArticleCardMeta({
  author,
  createdAt,
  className
}) {
  return /* @__PURE__ */ import_react9.default.createElement(
    ArticleMeta,
    {
      className,
      authorName: author,
      infos: createdAt ? [createdAt] : null,
      size: "medium"
    }
  );
}

// src/ArticleCard/index.ts
var ArticleCardWrapper = ArticleCard;
ArticleCardWrapper.Title = ArticleCardTitle;
ArticleCardWrapper.Summary = ArticleCardSummary;
ArticleCardWrapper.Meta = ArticleCardMeta;
ArticleCardWrapper.Footer = ArticleCardFooter;

// src/AticleCardWithImage/ArticelCardTemplateSimple.tsx
function ArticleCardTemplateSimple({
  title,
  author,
  createdAt,
  tags,
  hasVideo
}) {
  return /* @__PURE__ */ import_react10.default.createElement(ArticleCardTemplateSimpleCss, null, /* @__PURE__ */ import_react10.default.createElement("div", null, /* @__PURE__ */ import_react10.default.createElement(ArticleCardWrapper.Footer, { tags, hasVideo }), /* @__PURE__ */ import_react10.default.createElement(ArticleCardWrapper.Title, null, title)), /* @__PURE__ */ import_react10.default.createElement(ArticleCardTemplateSimpleFooterCss, null, /* @__PURE__ */ import_react10.default.createElement(ArticleCardWrapper.Meta, { author, createdAt })));
}
var ArticleCardTemplateSimpleCss = import_styled_components8.default.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  & > span {
    padding: ${(p) => p.theme.sizes.spacing5};
  }

  padding: ${(p) => p.theme.sizes.spacing5};
`;
var ArticleCardTemplateSimpleFooterCss = import_styled_components8.default.div`
  & > div:last-child {
    position: relative;
  }
`;

// src/AticleCardWithImage/ArticleCardTemplateRich.tsx
var import_styled_components9 = __toESM(require("styled-components"));
var import_react11 = __toESM(require("react"));
function ArticleCardTemplateRich({
  title,
  author,
  createdAt,
  tags,
  summary,
  hasVideo,
  largeTitle
}) {
  return /* @__PURE__ */ import_react11.default.createElement(ArticleCardTemplateRichCss, null, /* @__PURE__ */ import_react11.default.createElement("div", null, /* @__PURE__ */ import_react11.default.createElement(ArticleCardTemplateRichFooterCss, { tags, hasVideo }), /* @__PURE__ */ import_react11.default.createElement(ArticleCardTemplateRichContentCss, null, /* @__PURE__ */ import_react11.default.createElement(ArticleCardWrapper.Title, { large: Boolean(largeTitle) }, title), /* @__PURE__ */ import_react11.default.createElement(ArticleCardTemplateRichSummaryCss, null, summary), /* @__PURE__ */ import_react11.default.createElement(ArticleCardWrapper.Meta, { author, createdAt }))));
}
var ArticleCardTemplateRichCss = import_styled_components9.default.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding: ${(p) => p.theme.sizes.spacing5};
  border-radius: ${({
  theme: {
    sizes: { spacing1 }
  }
}) => `0 ${spacing1} ${spacing1} 0 `}
    & > span {
    padding: ${(p) => p.theme.sizes.spacing5};
  }
`;
var ArticleCardTemplateRichSummaryCss = (0, import_styled_components9.default)(ArticleCardWrapper.Summary)`
  display: -webkit-box;
  -webkit-line-clamp: 4;
  max-height: 50%;
  -webkit-box-orient: vertical;
`;
var ArticleCardTemplateRichContentCss = import_styled_components9.default.div`
  max-height: 80%;
  max-width: 100%;
`;
var ArticleCardTemplateRichFooterCss = (0, import_styled_components9.default)(ArticleCardWrapper.Footer)`
  width: calc(100% - ${(p) => p.theme.sizes.spacing6});
  left: ${(p) => p.theme.sizes.spacing5};
`;

// src/AticleCardWithImage/AticleCardWithImage.tsx
function ArticleCardContentTemplate(_a) {
  var _b = _a, {
    variant,
    className
  } = _b, articleProps = __objRest(_b, [
    "variant",
    "className"
  ]);
  return /* @__PURE__ */ import_react12.default.createElement(ArticleCardContentTemplateCss, { className, variant }, /* @__PURE__ */ import_react12.default.createElement(ArticleCardTemplateSimple, __spreadValues({}, articleProps)), /* @__PURE__ */ import_react12.default.createElement(
    ArticleCardTemplateRich,
    __spreadProps(__spreadValues({}, articleProps), {
      largeTitle: variant === "horizontalWide" || [variant == null ? void 0 : variant[2], variant == null ? void 0 : variant[3]].includes("horizontalWide")
    })
  ));
}
function ArticleCardWithImage(_a) {
  var _b = _a, {
    imageUrl,
    className,
    variant = "horizontalWide",
    imageNode
  } = _b, articleProps = __objRest(_b, [
    "imageUrl",
    "className",
    "variant",
    "imageNode"
  ]);
  return /* @__PURE__ */ import_react12.default.createElement(AticleCardWithImageCss, { className, variant }, imageNode ? /* @__PURE__ */ import_react12.default.createElement("div", { className: "image" }, imageNode) : /* @__PURE__ */ import_react12.default.createElement(ArticleCardImageCss, { src: imageUrl }), /* @__PURE__ */ import_react12.default.createElement(
    ArticleCardContentTemplate,
    __spreadProps(__spreadValues({
      className: "content"
    }, articleProps), {
      variant
    })
  ));
}
var ArticleCardContentTemplateCss = import_styled_components10.default.div`
  ${(p) => {
  const { variant } = p;
  const mapVariantToStyle = {
    horizontalWide: `
        & > div:first-child {
          display: none;
        }
      `,
    horizontalSquared: `
        & > div:first-child {
          display: none;
        }
      `,
    vertical: `
        & > div:last-child {
          display: none;
        }
      `
  };
  if (variant && typeof variant !== "object")
    return mapVariantToStyle[variant];
  return `
      ${p.theme.breakpoints.maxSm} {
        ${variant && mapVariantToStyle[variant[0]]}
      }
      ${p.theme.breakpoints.sm} {
        ${p.theme.breakpoints.maxLg} {
          ${variant && mapVariantToStyle[variant[1]]}
        }
      }
      ${p.theme.breakpoints.lg} {
        ${p.theme.breakpoints.maxXl} {
          ${variant && mapVariantToStyle[variant[2]]}
        }
      }
      ${p.theme.breakpoints.xl} {
        ${variant && mapVariantToStyle[variant[3] || variant[2]]}
      }
    `;
}}
`;
var AticleCardWithImageCss = import_styled_components10.default.div`
  width: 100%;
  display: flex;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.09), 0 0 0 0.5px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  background: ${(p) => p.theme.colors.white};

  img {
    transform: scale(1);
    transition: 0.3s ease-in-out;
  }

  &:hover {
    img {
      transform: scale(1.08);
    }
  }

  ${(p) => {
  const { spacing1 } = p.theme.sizes;
  const variant = p.variant;
  const mapVariantToStyle = {
    horizontalWide: `
        height: 100%;
        
        & > .content {
          width: 33%;
          border-radius: 0 ${spacing1} ${spacing1} 0;
        }

        & > img, & > .image {
          border-radius: ${spacing1} 0 0 ${spacing1};
          width: calc(100% - 33%);
        }
      `,
    horizontalSquared: `
        height: 100%;

        & > .content {
          width: 50%;
          border-radius: 0 ${spacing1} ${spacing1} 0;
        }

        & > img, & > .image {
          width: 50%;
          border-radius: ${spacing1} 0 0 ${spacing1};
        }
      `,
    vertical: `
        height: 100%;
        flex-direction: column;

        & > .content {
          flex: 1;
          border-radius: 0 0 ${spacing1} ${spacing1};
        }

        & > img, & > .image { 
          width: 100%;
          height: auto;
          border-radius: ${spacing1} ${spacing1} 0 0;
        }
      `
  };
  if (typeof variant !== "object")
    return mapVariantToStyle[variant];
  return `
      ${p.theme.breakpoints.maxSm} {
        ${mapVariantToStyle[variant[0]]}
      }
      ${p.theme.breakpoints.sm} {
        ${p.theme.breakpoints.maxLg} {
          ${mapVariantToStyle[variant[1]]}
        }
      }
      
      ${p.theme.breakpoints.lg} {
        ${p.theme.breakpoints.maxXl} {
          ${mapVariantToStyle[variant[2]]}
        }
      }
      ${p.theme.breakpoints.xl} {
        ${mapVariantToStyle[variant[3] || variant[2]]}
      }
    `;
}}
`;
var ArticleCardImageCss = import_styled_components10.default.img`
  object-fit: cover;
`;

// src/AticleCardWithImage/aticle-card-with-image-theme.ts
function makeAticleCardWithImageTheme(baseTheme) {
  const { defaultColors, sizes } = baseTheme;
  return {};
}

// src/AticleCardWithImage/use-variant-based-on-screen-size.ts
var import_react_responsive = require("react-responsive");
var import_styled_components11 = require("styled-components");
function useVariantBasedOnScreenSize(variant) {
  const theme = (0, import_styled_components11.useTheme)();
  const isSmall = (0, import_react_responsive.useMediaQuery)({ maxWidth: theme.breakpointSizes.sm });
  const isMedium = (0, import_react_responsive.useMediaQuery)({
    maxWidth: theme.breakpointSizes.lg,
    minWidth: theme.breakpointSizes.sm
  });
  const isLarge = (0, import_react_responsive.useMediaQuery)({
    maxWidth: theme.breakpointSizes.xl,
    minWidth: theme.breakpointSizes.lg
  });
  if (typeof variant !== "object")
    return variant;
  if (isSmall)
    return variant[0];
  if (isMedium)
    return variant[1];
  if (isLarge)
    return variant[2];
  return variant[3] || variant[2];
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ArticleCardWithImage,
  makeAticleCardWithImageTheme,
  useVariantBasedOnScreenSize
});
